import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import {TranslateService} from 'ng2-translate/ng2-translate';
import {LoginService} from '../../services/login.service';
import {ProvidersService} from '../../services/providers.service';
import { DeviceDetectorService } from 'ngx-device-detector';


@Component({
  selector: 'app-recover',
  templateUrl: './recover.component.html',
  styleUrls: ['./recover.component.scss']
})
export class RecoverComponent implements OnInit {
  user: any = {};
  loadBtn=false;

  tokenIsvalid=true;
  TokenUser;
  User;

  message;
  language= 'es';
  errosTostr;
  successToastr;

  password;
  cpassword;

  constructor(private toastr: ToastrService, public dialog: MatDialog, private router: Router, private authService: LoginService, public translate: TranslateService, private provService: ProvidersService, private deviceService: DeviceDetectorService, private activeRoute: ActivatedRoute) {
    //this.user.username = this.data.user;
    const queryParams = this.activeRoute.snapshot.queryParams
    const routeParams = this.activeRoute.snapshot.params;
    this.TokenUser = routeParams.token;
    this.User = routeParams.usuario;

    this.language = (localStorage.getItem('language'))? localStorage.getItem('language') : 'es' ;
    this.translate.use(this.language);

  }

  ngOnInit() {
    this.validateToken();
    this.translate.getTranslation(this.language).subscribe((res:any)=>{
      this.errosTostr = res.ERRORTOASTR;
      this.successToastr = res.SUCCESSTOASTR;
    });
  }

  send() {
    //this.dialogRef.close({ data: 'data' });
  }

  onCloseCancel() {
    //this.dialogRef.close();
  }

  update(){
    if(this.password != this.cpassword){
      this.toastr.error('La nueva contraseña y confirmar contraseña no coinciden', '', {timeOut: 18000, enableHtml: true});
    }else{
      let params = { 
        Usuario: this.User,
        Token: this.TokenUser, 
        NuevoPassword: this.password
      }
      this.authService.updateNewPassword(params).then((res:any)=>{
        if(res.EsValido){
          this.router.navigate(['/']);
          this.toastr.success('Contraseña restablecida correctamente, ahora puedes iniciar sesión ', '', {disableTimeOut: true, closeButton: true});
        }else{
          this.toastr.error('La contraseña debe contener al menos 8 caracteres, una letra mayúscula, una letra minúscula, un número y un caracter especial.', '', {timeOut: 18000, enableHtml: true});
        }
      });
    }
  }

  validateToken(){
    let params = { 
      Usuario: this.User,
      Token: this.TokenUser
    }
    this.authService.validateRecovery(params).then((res:any)=>{
      if(!res.EsValido){
        this.toastr.error('Esta petición a caducado, solicitala nuevamente', '', {timeOut: 18000, enableHtml: true});
        this.router.navigate(['/']);
      }

      if(!res.Entidad.EsValido){
        this.toastr.error('Esta petición a caducado, solicitala nuevamente', '', {timeOut: 18000, enableHtml: true});
        // this.toastr.error(this.successToastr.SUCCESSRECOVERY, '', {disableTimeOut: true, closeButton: true});
        //this.toastr.success(this.successToastr.SUCCESSRECOVERY, '', {disableTimeOut: true, closeButton: true});
        this.router.navigate(['/']);
      }
    });
  }



}
